const definitionListItemVisibleClass = "process_map__definitions__item--active";

module.exports = {
    // hide definition list, and active definition list item,
    // on interaction with a definition list item close button
    init: () => {
        // get all definition list item close buttons
        const closeButtonsClass      = ".close_node";
        const closePhaseButtonsClass = ".close_phase";
        const closePhaseButtons      = document.querySelectorAll(closePhaseButtonsClass);
        const closeButtons           = document.querySelectorAll(closeButtonsClass);
        if (!closeButtons) {
            console.error(`Could not find any buttons with the selector: ${closeButtonsClass}`);
            return;
        };
        if (!closePhaseButtons) {
            console.error(`Could not find any buttons with the selector: ${closePhaseButtonsClass}`);
            return;
        };
        // get darker overlay
        const darkerOverlayClass = ".darker";
        const darkerOverlay      = document.querySelector(darkerOverlayClass);
        const closeAll = function (event) {
            // this removes darken overlay
            darkerOverlay.classList.remove("darken");
            const closeButton = event.target;
            // find the list item with the matching data definition id and remove from it the active class
            const dialog = document.querySelector("li[data-definition-id=" + closeButton.dataset.definitionId + "]");
            dialog.classList.remove(definitionListItemVisibleClass);
            // find that list item's parent definition container and remove from it the active class
            const definitionListOpenClass = "process_map__definitions--is_visible";
            const parentDefinitionList = dialog.parentNode.parentNode;
            if (parentDefinitionList.classList.contains(definitionListOpenClass)) {
                parentDefinitionList.classList.remove(definitionListOpenClass);
            }
            // find the definition toggle button with the matching data definition id and remove from it the active class
            const definitionToggleButton = document.querySelector("button[data-definition-id=" + closeButton.dataset.definitionId + "]");
            const definitionToggleButtonActiveClass = "process_map__lane__sub_lane__toggle--active";
            definitionToggleButton.classList.remove(definitionToggleButtonActiveClass);
            // this removes --active class from phase arrow path and phase item
            const arrow = definitionToggleButton.parentElement.getElementsByClassName("process_map__phases__item__arrow__shadow__path");
            arrow[0].classList.remove("process_map__phases__item__arrow__shadow__path--active");
            definitionToggleButton.parentElement.parentElement.classList.remove("process_map__phases__item--active");
            // find the phase information toggle button with the matching data definition id and remove from it the active class
            const phaseInfoToggleButtonActiveClass = "process_map__phases__action--active";
            definitionToggleButton.classList.remove(phaseInfoToggleButtonActiveClass);
            // remove active class from the phase title
            let phaseTitleActiveClass = "process_map__phase__title--active";
            let phaseTitle = definitionToggleButton.nextElementSibling;
            phaseTitle.classList.remove(phaseTitleActiveClass);
        };
        // function to get value of CSS rule for given class
        function GetProperty (classOrId, property) {
            var FirstChar = classOrId.charAt(0);  var Remaining = classOrId.substring(1);
            var elem = (FirstChar == '#') ?  document.getElementById(Remaining) : document.getElementsByClassName(Remaining)[0];
            return window.getComputedStyle(elem, null).getPropertyValue(property);
        }
        // loop through all close buttons to attach click events
        closeButtons.forEach(element => {
            element.addEventListener("click", closeAll, true);
        });
        closePhaseButtons.forEach(element => {
            element.addEventListener("click", closeAll, true);
            element.addEventListener("click", () => {
                const phasesClass = ".process_map__phases";
                const phases      = document.querySelector(phasesClass);
                if (GetProperty(phasesClass, "position") === "relative") {
                    phases.style.position = "sticky";
                    document.documentElement.style.overflow = "auto";
                } else if (GetProperty(phasesClass, "position") === "sticky") {
                    phases.style.position = "relative";
                    document.documentElement.style.overflow = "auto";
                };
                if (GetProperty(phasesClass, "z-index") === "5") {
                    phases.style.zIndex = "auto";
                } else if (GetProperty(phasesClass, "z-index") === "auto") {
                    phases.style.zIndex = "5";
                };
            }, true);
        });
    }
};
